import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useEffect, useRef, useState } from 'react';
import { getInputValue, setInputValue } from '../../util/refUtils';
import { agregaTipoSiniestro, eliminarDuenoSiniestro, modificaTipoSiniestro } from '../../services/Siniestro/SiniestroService';

const AdiSector = ({ funcSalir, datSector }) => {
    const refNombreSector = useRef();
    const adiSectorToast = useRef();
    const [guardando, setGuardando] = useState(false);
    const [eliminando, setEliminando] = useState(false);
    const [confEliminar, setConfEliminar] = useState(false);

    useEffect(() => {
        if (datSector?.configuracionDetId) {
            setInputValue(refNombreSector, datSector?.nombre);
        }
    }, [datSector?.configuracionDetId, datSector?.nombre]);

    const handleGuardar = async () => {
        const valNombre = getInputValue(refNombreSector);
        if (!valNombre) {
            adiSectorToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el campo Nombre.'
            });
            return;
        }
        
        try {
            setGuardando(true);
            const CODIGO_CAB_SECTOR = 'SIN-0000-SECT'; 
            const objData = {
                nombre: valNombre
            };
            
            let data;
            if (datSector?.configuracionDetId) {
                objData['configuracionDetId'] = datSector?.configuracionDetId;
                data = await modificaTipoSiniestro(objData);
            } else {
                objData['codigo'] = CODIGO_CAB_SECTOR;
                data = await agregaTipoSiniestro(objData);
            }
            
            if (data.configuracionDetId) {
                adiSectorToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha guardado el Sector'
                });
            }
        } catch (error) {
            adiSectorToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al Guardar el Sector'
            });
        } finally {
            setGuardando(false);
            funcSalir();
        }
    };

    const confirmarEliminar = async () => {
        if (!datSector?.configuracionDetId) return;
        try {
            setEliminando(true);
            await eliminarDuenoSiniestro(datSector.configuracionDetId);
            adiSectorToast.current.show({
                severity: 'success',
                summary: 'Exito',
                detail: 'Sector eliminado.'
            });
            setConfEliminar(false);
            funcSalir();
        } catch (error) {
            adiSectorToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el Sector.'
            });
        } finally {
            setEliminando(false);
        }
    };

    return (
        <div className="card">
            <Toast ref={adiSectorToast} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-3">
                    <label>Codigo Padre: </label>
                </div>
                <div className="field col-12 md:col-9">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        Sector del Evento
                    </span>
                </div>
                <div className="field col-12 md:col-12 mt-2">
                    <label>Nombre del Sector: </label>
                    <InputText
                        ref={refNombreSector}
                        defaultValue=""
                        onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        maxLength={100}
                    />
                </div>
                <div className="field col-12 md:col-4">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-4 flex align-items-end mt-2">
                    <Button
                        label="Eliminar"
                        className="p-button-danger"
                        icon="pi pi-trash"
                        disabled={!datSector?.configuracionDetId}
                        onClick={() => setConfEliminar(true)}
                        loading={eliminando}
                    />
                </div>
                <div className="field col-12 md:col-4 flex align-items-end mt-2">
                    <Button label="Guardar" icon="pi pi-save" loading={guardando} onClick={handleGuardar} />
                </div>
            </div>
            <ConfirmDialog
                visible={confEliminar}
                onHide={() => setConfEliminar(false)}
                message={`¿Confirma eliminar el sector "${datSector?.nombre}"?`}
                header="Eliminar Sector"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Si"
                rejectLabel="No"
                acceptClassName="p-button-danger"
                accept={confirmarEliminar}
            />
        </div>
    );
};

export default AdiSector;
